// frontend/src/components/InstructionPopup/InstructionPopup.js

import React, { useState, useEffect } from 'react';
import './InstructionPopup.css';

/**
 * InstructionPopup
 *
 * Props:
 *   onClose (function) - kallas när man stänger popupen
 *   onSubmit (function) - kallas när man klickar "Spara" (eller valfritt)
 *   targetRef (optional) - en ref till en DOM-element
 *       om du vill positionera popuppen i förhållande till ett "target".
 */

const InstructionPopup = ({ onClose, onSubmit, targetRef }) => {
  const [instruction, setInstruction] = useState('');

  const [popupStyle, setPopupStyle] = useState({
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  });

  // Använd en effect för att beräkna position om targetRef finns
  useEffect(() => {
    if (targetRef && targetRef.current) {
      const rect = targetRef.current.getBoundingClientRect();
      // Du kan justera hur du vill positionera:
      setPopupStyle({
        position: 'absolute',
        top: `${rect.bottom + 10}px`,
        left: `${rect.left}px`,
      });
    }
  }, [targetRef]);

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit(instruction);
    }
    setInstruction('');
  };

  const handleClose = () => {
    if (onClose) onClose();
    setInstruction('');
  };

  return (
    <div className="instruction-popup" style={popupStyle}>
      <h4>Skriv din instruktion</h4>
      <textarea
        value={instruction}
        onChange={(e) => setInstruction(e.target.value)}
        placeholder="Ange instruktion..."
      />
      <div className="instruction-popup-buttons">
        <button onClick={handleClose}>Avbryt</button>
        <button onClick={handleSubmit}>Skicka</button>
      </div>
    </div>
  );
};

export default InstructionPopup;
